'use client'
import React, { useState } from 'react'
import ReviewForm from './ReviewForm'
import Reviews from './Reviews'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import {
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  Scrollbar,
  Mousewheel,
} from 'swiper/modules'
import Link from 'next/link'
import { useContextElement } from '@/context/Context'
import styles from './PhotoAlbum.module.css'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/free-mode'
import 'swiper/css/thumbs'
import 'swiper/css/scrollbar'

export default function PhotoAlbum({ data }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const safeThumbs =
    thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null

  return (
    <section className="blog-page blog-single container">
      <div className="mw-930">
        <div className="d-flex row">
          <div className="space-y-3 col-md-8">
            {/* 主圖 */}
            <Swiper
              modules={[Navigation, Pagination, Thumbs]}
              navigation
              pagination={{ clickable: true }}
              thumbs={{ swiper: safeThumbs }}
              slidesPerView={1}
              spaceBetween={0}
              centeredSlides={false}
              roundLengths={true}
              observer
              observeParents
              style={{ width: '80%', height: 470 }}
              className="mb-2 main-swiper"
              onSlideChange={(swiper) => {
                const idx = swiper.realIndex ?? swiper.activeIndex
                safeThumbs?.slideTo(idx, 500, false)
              }}
            >
              {data.MediaData.map((m, i) => (
                <SwiperSlide key={i}>
                  <img
                    src={m.PicturePath}
                    alt={`img-${i}`}
                    loading="lazy"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* 可滾動縮圖列 */}
            <Swiper
              className={styles.thumbBar}
              modules={[Thumbs, Scrollbar, Mousewheel]}
              onSwiper={setThumbsSwiper}
              watchSlidesProgress
              slideToClickedSlide
              mousewheel={{ forceToAxis: true }}
              scrollbar={{ draggable: true }}
              slidesPerView={'auto'}
              centeredSlides
              centeredSlidesBounds
              spaceBetween={8}
              style={{ width: 350, height: 92, paddingBottom: 8 }}
            >
              {data.MediaData.map((m, i) => (
                <SwiperSlide key={i} className={styles.thumbSlide}>
                  <img
                    src={m.PicturePath}
                    alt={`thumb-${i}`}
                    loading="lazy"
                    className={styles.thumbImg}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="col-md-4">
            <span style={{ fontSize: '24px' }}>{data.ArticleTitle}</span>
            <div className="blog-single__item-meta mb-3">
              <span className="blog-single__item-meta__date">
                更新日期 : {data.PublishedDateFormatted}
              </span>
              <span className="blog-single__item-meta__date">
                閱讀次數 : {data.ViewCount}
              </span>
            </div>
            <div>
              <span>{data.Description}</span>
            </div>
          </div>
        </div>
      </div>

      {data.Content && data.Content != '' && (
        <>
          <div className="mw-930 mt-4">文章內容</div>
          <div
            className="blog-single__item-content d-flex flex-column align-items-center"
            dangerouslySetInnerHTML={{ __html: data.Content }}
          ></div>
        </>
      )}
    </section>
  )
}
